import { notFound } from "@tanstack/react-router";
import type { Schemas } from "@softmax/observatory-client/types";
import { readCommunity } from "@/features/community/records";

export async function getReport({
  data,
  signal,
}: {
  data: { slug: string };
  signal?: AbortSignal | undefined;
}) {
  const code = /-([A-Za-z0-9]{10})$/.exec(data.slug)?.[1];

  if (!code) throw notFound();

  const result = await readCommunity<Schemas["FeedReportPublic"]>({
    signal,
    path: `/v2/feed-reports/${encodeURIComponent(code)}`,
  });

  if (result.status === "not-found") throw notFound();

  if (result.status === "unavailable")
    throw new Error("This report could not be loaded");

  return result.data;
}
